import {
  // 表格功能
  VXETable,
  Column,
  Pager,
  Select,
  Input,
  Header,
  Filter,
  Table,
  Icon,
  Toolbar,
  Button,
  Checkbox,
  Grid,
  CheckboxGroup,
  Export,
  Tooltip,
  // 可选组件
  // Footer,
  // Colgroup,
  // Tooltip,
  // FormGather,
  Radio,
  // RadioGroup,
  // RadioButton,
  // Switch,
  // Optgroup,
  // Option,
  // Textarea,
  // List,
  // Pulldown,
  // Edit,
  // Menu,
  // Keyboard,
  // Validator
} from 'vxe-table';
import zhCN from 'vxe-table/es/locale/lang/zh-CN';
import XEUtils from 'xe-utils';
import { defineAsyncComponent } from 'vue';

VXETable.setup({
  i18n: (key, args) => XEUtils.toFormatString(XEUtils.get(zhCN, key), args)
});
export default function (app) {
  // app.component(
  //   'VxeGrid',
  //   defineAsyncComponent(() =>
  //     import(/* webpackChunkName: "vxeGrid" */ 'vxe-table/lib/grid').then((data) => data.default)
  //   )
  // );

  app
    .use(Header)
    .use(Filter)
    .use(Input)
    .use(Select)
    .use(Column)
    .use(Pager)
    .use(Table)
    .use(Icon)
    .use(Toolbar)
    .use(Button)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(Grid)
    .use(Export)
    .use(Tooltip)
    .use(Radio)
  // 可选组件
  // .use(Footer)
  // .use(Colgroup)
  // .use(Tooltip)
  // .use(FormGather)

  // .use(Radio)
  // .use(RadioGroup)
  // .use(RadioButton)
  // .use(Switch)
  // .use(Optgroup)
  // .use(Option)
  // .use(Textarea)
  // .use(List)
  // .use(Pulldown)
  // .use(Edit)
  // .use(Menu)
  // .use(Keyboard)
  // .use(Validator);

  app.config.globalProperties.$XModal = VXETable.modal;
  app.config.globalProperties.$XPrint = VXETable.print;
  app.config.globalProperties.$XSaveFile = VXETable.saveFile;
  app.config.globalProperties.$XReadFile = VXETable.readFile;
}
